import {AdapterLuxon} from "@mui/x-date-pickers/AdapterLuxon";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {useIntl} from "react-intl";
import {ReactNode} from "react";

const DatePickerLocalizationProvider = ({children}: {children: ReactNode}) => {
    const intl = useIntl();

    return (
        <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale={intl.locale}>
            {children}
        </LocalizationProvider>
    );
};

export default DatePickerLocalizationProvider;
